<script>
import feather from 'feather-icons';
import ProjectsFilter from './ProjectsFilter.vue';
import ProjectSingle from './ProjectSingle.vue';
import axios from 'axios';

export default {
  components: { ProjectSingle, ProjectsFilter },
  data: () => ({
    projects: [], // Start with an empty array
    projectsHeading: 'Projects Portfolio',
    selectedCategory: '',
    searchProject: '',
  }),
  computed: {
    // Get the filtered projects
    filteredProjects() {
      let filtered = this.projects;

      // If both category and search are selected, apply both filters
      if (this.selectedCategory && this.searchProject) {
        // Filter by category first
        filtered = this.filterProjectsByCategory(filtered);
        
        // Then filter by search term on the already category-filtered list
        filtered = this.filterProjectsBySearch(filtered);
      } 
      // If only category is selected
      else if (this.selectedCategory) {
        filtered = this.filterProjectsByCategory(filtered);
      } 
      // If only search is provided
      else if (this.searchProject) {
        filtered = this.filterProjectsBySearch(filtered);
      }

      return filtered;
    },
    // Limit the number of projects to 6 on the home page
    projectsToShow() {
          // Check if we are on the home page by path (root '/')
          if (this.$route.path === '/') {
            return this.filteredProjects.slice(-6); // Get the last 6 projects
          }
          return this.filteredProjects; // Show all projects on other pages
        },
  },
  methods: {
    // Fetch projects from the Gist using the GitHub API
    async fetchProjects() {
      try {
        // GitHub API endpoint for fetching the latest Gist version
        const gistUrl = 'https://api.github.com/gists/11f38768062e6e8ce83aea4581916355';

        // Fetch the Gist data
        const gistResponse = await axios.get(gistUrl);

        // Get the raw URL for the projects.json file
        const rawUrl = gistResponse.data.files['website.json'].raw_url;

        // Fetch the JSON file content from the raw URL
        const response = await axios.get(rawUrl);

        // Update the projects data
        this.projects = response.data.projects;
      } catch (error) {
        console.error('Error fetching projects:', error);
      }
    },
    // Filter projects by category
    filterProjectsByCategory(projects) {
      // Normalize and split selectedCategory into keywords (based on '/')
      const selectedKeywords = this.selectedCategory.toLowerCase().split('/').map(keyword => keyword.trim());

      return projects.filter((item) => {
        // Normalize and split category into keywords
        const categoryKeywords = item.category.toLowerCase().split('/').map(keyword => keyword.trim());

        // Check if at least one selectedKeyword matches any part of the category
        return selectedKeywords.some(keyword => categoryKeywords.some(category => category.includes(keyword)));
      });
    },
    // Filter projects by title search
    filterProjectsBySearch(projects) {
      let project = new RegExp(this.searchProject, 'i');
      return projects.filter((el) => el.title.match(project));
    },
  },
  mounted() {
    this.fetchProjects(); // Fetch the projects when the component is mounted
    // Poll every 5 minutes (300000ms) to check for updates
    setInterval(this.fetchProjects, 600000); // 5-minute interval
    feather.replace();
  },
};
</script>

<template>
  <section class="pt-10 sm:pt-14">
    <div class="text-center">
      <p class="font-general-semibold text-2xl sm:text-5xl font-semibold mb-2 text-ternary-dark dark:text-ternary-light">
        {{ projectsHeading }}
      </p>
    </div>

    <div class="mt-10 sm:mt-10">
      <h3 class="font-general-regular text-center text-secondary-dark dark:text-ternary-light text-md sm:text-xl font-normal mb-4">
        Search projects by title or filter by category
      </h3>
      <div class="flex justify-between border-b border-primary-light dark:border-secondary-dark pb-3 gap-2">
        <div class="flex justify-between gap-2">
          <span class="hidden sm:block bg-primary-light dark:bg-ternary-dark p-2.5 shadow-sm rounded-xl cursor-pointer">
            <i data-feather="search" class="text-ternary-dark dark:text-ternary-light"></i>
          </span>
          <input v-model="searchProject" class="font-general-medium pl-3 pr-1 sm:px-4 py-2 border-1 border-gray-200 dark:border-secondary-dark rounded-lg text-sm sm:text-md bg-secondary-light dark:bg-ternary-dark text-primary-dark dark:text-ternary-light" id="name" name="name" type="search" required placeholder="Search Projects" aria-label="Name" />
        </div>
        <ProjectsFilter @filter="selectedCategory = $event" />
      </div>
    </div>

    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 mt-6 sm:gap-10">
      <!-- Loop through the filteredProjects array in reverse order and render ProjectSingle components -->
      <!-- <ProjectSingle v-for="project in filteredProjects.slice().reverse()" :key="project.id" :project="project" /> -->
      <ProjectSingle v-for="project in projectsToShow.slice().reverse()" :key="project.id" :project="project" />

    </div>
  </section>
</template>

<style scoped>
</style>
